import React from 'react';
import MainTitle from '@PROJECT_ROOT/assets/responsive-frontend/js/parts/mainTitle';

export default function AxiosError() {
    const axiosErrors = JSON.parse(document.getElementById('mainWrapper').getAttribute('data-axios'));
    return (
        <>
            {axiosErrors && (
                <div id="axiosErrorReact" className="row">
                    {axiosErrors.pageTitle && (
                        <div className="axios-error__page-title col-12">
                            <MainTitle title={axiosErrors.pageTitle} />
                        </div>
                    )}
                    <div className="axios-error__text-wrap col-12 col-md-5">
                        <p className="axios-error__title">{axiosErrors.title}</p>
                        <p className="axios-error__text">{axiosErrors.firstText}</p>
                        <p className="axios-error__text">{axiosErrors.secondText}</p>
                    </div>
                    <div className="axios-error__svg-wrap col-12 col-md-7">
                        <div className="axios-error__svg" />
                    </div>
                </div>
            )}
        </>
    );
}
